// Load utils
import { debounce, updateLayoutVars, setCSSVar } from "./tools/utils";
// import { gridDebug } from "./tools/gridDebug";

// Load components
import { BurgerMenu } from "./components/burgerMenu";

function setCookie(name, value, days = 365, path = "/") {
	let expires = "";
	if (days) {
	  const date = new Date();
	  date.setTime(date.getTime() + (days*24*60*60*1000));
	  expires = "; expires=" + date.toUTCString();
	}
	document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=${path}`;
}

document.addEventListener("DOMContentLoaded", (e) => {
	// Load grid debug on dev environement
	// if (themeVars.is_dev) gridDebug.init();

	// update layout vars
	updateLayoutVars();
	window.addEventListener("resize", debounce(updateLayoutVars, 150));

	// Init components
	BurgerMenu.init();

	// Sitcky header
	const header = document.querySelector(".header");
	const headerTop = header.getBoundingClientRect().top;

	setCSSVar("--_header-h", `${header.offsetHeight}px`);

	window.addEventListener("scroll", () => header.classList.toggle("is-sticky", window.scrollY > headerTop + header.offsetHeight));

	const searchBtn = document.getElementById("searchBtn");
	const searchForm = document.getElementById("searchForm");
	const searchbox = document.getElementById("searchbox");

	if (!searchBtn || !searchForm || !searchbox) return;

	// Toggle au clic sur le bouton
	searchBtn.addEventListener("click", (e) => {
		e.stopPropagation();
		const isVisible = searchForm.classList.contains("is-visible");

		if (isVisible) {
			searchForm.classList.remove("is-visible");
		} else {
			searchForm.classList.add("is-visible");

			// Focus sur le champ texte
			const input = searchForm.querySelector("input[type='search'], input[type='text']");
			if (input) {
				input.focus();
			}
		}
	});

	// Masquer au clic extérieur
	document.addEventListener("click", (e) => {
		if (!searchbox.contains(e.target)) {
			searchForm.classList.remove("is-visible");
		}
	});

	// Empêcher la fermeture quand on clique dans le formulaire
	searchForm.addEventListener("click", (e) => {
		e.stopPropagation();
	});

	// Afficher la carte si les cookies sont acceptés
	document.addEventListener("click", function(e) {
		if (e.target.tagName.toLowerCase() == 'span' && e.target.closest("#job_map")) {

			setCookie("cmplz_statistics", "deny");
			setCookie("cmplz_marketing", "allow");

			const script = document.createElement("script");
			script.src = "https://maps.googleapis.com/maps/api/js?callback=initMap&key=" + themeVars.map_key;
			document.head.appendChild(script);
	
		}
	});

});
